/* eslint-disable max-len */
import * as questionIds from "../../questions/questionIds";

export const personalDetailsQuestions = [
    {
        id: questionIds.Title,
        questionText: "Title"
    },
    {
        id: questionIds.FirstName,
        questionText: "First Name",
    },
    {
        id: questionIds.LastName,
        questionText: "Last Name",
    },
    {
        id: questionIds.Dob,
        questionText: "Date of Birth",
    },
    {
        id: questionIds.Gender,
        questionText: "Gender",
    },
    {
        id: questionIds.AddressLine1,
        questionText: "Address Line 1",
    },
    {
        id: questionIds.AddressLine2,
        questionText: "Address Line 2",
    },
    {
        id: questionIds.AddressLine3,
        questionText: "Address Line 3",
    },
    {
        id: questionIds.City,
        questionText: "City",
    },
    {
        id: questionIds.County,
        questionText: "County",
    },
    {
        id: questionIds.Postcode,
        questionText: "Postcode",
    },
    {
        id: questionIds.MobilePhone,
        questionText: "Mobile Telephone",
    },
    {
        id: questionIds.HomePhone,
        questionText: "Home Telephone",
    },
    {
        id: questionIds.OrgLevelId,
        questionText: "Org Level",
    },
    {
        id: questionIds.OrgLevelName,
        questionText: "Org Level",
    },
    {
        id: questionIds.StartDateOfEmployment,
        questionText: "Start Date of Employment",
    },
    {
        id: questionIds.ShiftPattern,
        questionText: "Shift Pattern",
    },
    {
        id: questionIds.StandardHours,
        questionText: "Standard Hours per Week",
    },
];
